import { tryFetch } from '@/modules/services/http'
import { HttpMethod } from '@/modules/services/http/types/http.enums'
import type { Search, SearchResult } from '../models/search.model'

const BASE_URL = import.meta.env.VITE_MAIN_BASE_URL

const getSearchResult = async (
  body: Search,
): Promise<{ data?: SearchResult; error?: any; status: number }> =>
  await tryFetch(HttpMethod.Post, BASE_URL, ['search'], { view: true, body })

export const searchApi = {
  getSearchResult,
}
